// removed by extract-text-webpack-plugin
module.exports = {"signature":"_1nXatdCS9Zd-8miogkvL_A"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Sign/Document/Page/Field/Show/Signature/Image/styles.css
// module id = 2920
// module chunks = 0